import React from "react";
import {Brands} from "@core-ui/utility";
import {useTheme} from "@core-ui/react-stitch";
import {Icon} from "../components/Icon";
import {IconContainerProps, ColorTheme} from "../types";

export const ChevronIcon = (props: IconContainerProps): JSX.Element => {
  const theme = useTheme();
  const {colorTheme} = props;
  const isLight = colorTheme === ColorTheme.light;

  const AthletaSVG = (
    <svg viewBox="0 0 26.78 17.63" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 1.95l13 15.68L26.79 1.98 24.53 0 13.08 13.01 2.3.03z"
        fill={isLight ? "#fff" : "#000"}
      />
    </svg>
  );

  const BananaRepublicSVG = (
    <svg fill="none" viewBox="0 0 28 13" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="M14.2211 12.2784L27.5 1.2161 26.8781.5 13.9918 11.2352 1.12192.513669.5 1.22977 13.8726 12.3701l.1001.1152.0191-.0159.0368.0306.1925-.2216z"
        fill="#000"
        fillRule="evenodd"
      />
    </svg>
  );

  const GapSVG = (
    <svg viewBox="0 0 18 7.742" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0,.839,6.44,9,0,17.162.818,18,7.743,9.225,7.522,9l.22-.225L.818,0Z"
        fill={isLight ? theme.color.wh : theme.color.b1}
        transform="translate(18) rotate(90)"
      />
    </svg>
  );

  const OldNavySVG = (
    <svg viewBox="0 0 13.29 8.07" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.13 7.86a.73.73 0 001.04 0l5.92-5.92a.73.73 0 000-1.03l-.7-.7a.73.73 0 00-1.03 0l-4.71 4.7L1.94.2A.73.73 0 00.9.21l-.69.7a.73.73 0 000 1.03z"
        fill={isLight ? theme.color.wh : theme.color.b1}
      />
    </svg>
  );

  const CrossBrandSVG = (
    <svg fill="none" viewBox="0 0 29 16" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="M1.77629.741717L.548584 1.96937 13.0679 14.5183l-.0045.0045.1395.1308 1.0738 1.0764.037-.0346.0308.0289.9432-.9425.2701-.2533-.0083-.0083L28.035 2.04513 26.8212.759646 14.3077 13.2779 1.77629.741717z"
        fill="#000"
        fillRule="evenodd"
      />
    </svg>
  );

  const brandIconSVGs = {
    [Brands.Athleta]: AthletaSVG,
    [Brands.BananaRepublic]: BananaRepublicSVG,
    [Brands.BananaRepublicFactoryStore]: BananaRepublicSVG,
    [Brands.Gap]: GapSVG,
    [Brands.GapFactoryStore]: GapSVG,
    [Brands.OldNavy]: OldNavySVG,
    crossBrand: CrossBrandSVG,
  };

  return <Icon {...props} brandIconSVGs={brandIconSVGs} />;
};
